<div [@fadeOutTrigger]="landscapeSectionState" class="password-prompt top">
  <h1 style="font-size:6vw;">Rotate your phone to landscape to continue!</h1>
</div>


<div [@fadeOutTrigger]="passwordPopupState" class="password-prompt">
  <h1>Good work! You’ve discovered each fragment of my magic from across the five kingdoms. </h1>
  <h3>Now there’s no time to waste.</h3>

  <h3>Rearrange the letters to make sense of this riddle.</h3>
  <blockquote><h2 style="color:white;">How do we enter and leave this world?</h2></blockquote>

<!--  Ordering challenge -->

  <div cdkDropList cdkDropListOrientation="horizontal" class="example-list" (cdkDropListDropped)="drop($event)">
    <div class="example-box" *ngFor="let letter of letters" cdkDrag><p style="text-align: center;width: 100%;">{{letter}}</p></div>
  </div>

</div>

<div class="example-list fixed-list" [@slowFadeOutTrigger]="lettersContainerState">
  <div class="example-box fixed" [@letterATrigger]="states.letterAState"><p style="text-align: center;width: 100%;">A</p></div> <!--     transform: translate(calc(400% + 80px), 0px); -->
  <div class="example-box fixed" [@letterLTrigger]="states.letterLState"><p style="text-align: center;width: 100%;">L</p></div> <!-- transform: translate(calc(-100% + -20px), 0px); -->
  <div class="example-box fixed" [@letterOTrigger]="states.letterOState"><p style="text-align: center;width: 100%;">O</p></div>
  <div class="example-box fixed" [@letterNTrigger]="states.letterNState"><p style="text-align: center;width: 100%;">N</p></div>
  <div class="example-box fixed" [@letterETrigger]="states.letterEState"><p style="text-align: center;width: 100%;">E</p></div> <!-- transform: translate(calc(-300% + -60px), 0px); -->
</div>



<app-video-player *ngIf="sectionPopupState != 'shown'" (videoEnded)="videoEnded()" (videoStarted)="startedPlaying()" [fullscreen]="false" src="https://storage.googleapis.com/twisted-media/section7.mp4" #playerComponent></app-video-player>
<div [@fadeOutTrigger]="sectionPopupState" class="password-prompt">
  <h1 style="font-size:6vw;">Congratulations, you’ve been twisted</h1>
  <h2>Share your experience with the mortal realm on social media.</h2>
  <div class="fb-share-button"
       data-href="https://paperworktheatre.co.uk/theatre/twisted/"
       data-layout="button">
  </div>
  <h2>Remember: don’t reveal any secrets to keep the magic alive for the next players</h2>

  <img src="../../assets/img/LOGO%20copy.jpg" style="width: 50%;float:left;"/>
  <img src="../../assets/img/lottery_Logo_Black%20RGB.jpg" style="float: left;width: 48%;margin-left: 2%;"/>

</div>
